// Маршрутизация верхнего уровня: /login, /activate — вне защищённой оболочки (RequireAuth).
import { useCallback, useEffect, useMemo, useState } from "react";
import { PUBLIC_PATHS } from "./publicPaths";
function usePathname() {
    const [pathname, setPathname] = useState(() => window.location.pathname);
    useEffect(() => {
        const onPop = () => setPathname(window.location.pathname);
        window.addEventListener("popstate", onPop);
        return () => window.removeEventListener("popstate", onPop);
    }, []);
    return pathname;
}
export function useAppRouting() {
    const pathname = usePathname();
    const isLoginPath = pathname === PUBLIC_PATHS[0];
    const isActivatePath = pathname === PUBLIC_PATHS[1];
    const activateToken = useMemo(() => (isActivatePath ? new URLSearchParams(window.location.search).get("t") : null), [isActivatePath]);
    // Токен активации не должен оставаться в адресной строке/истории браузера после чтения.
    useEffect(() => {
        if (isActivatePath && activateToken)
            window.history.replaceState(null, "", "/activate");
    }, [isActivatePath, activateToken]);
    // Небольшая задержка даёт увидеть stage="done" экрана перед полной перезагрузкой —
    // свежий bootstrap()/меню в новой сессии надёжнее переиспользования старого состояния.
    const handleLoginSuccess = useCallback(() => {
        setTimeout(() => window.location.assign("/"), 600);
    }, []);
    const handleActivateSuccess = useCallback(() => {
        setTimeout(() => window.location.assign("/"), 600);
    }, []);
    return { isLoginPath, isActivatePath, activateToken, handleLoginSuccess, handleActivateSuccess };
}
